export default {
    download: '下载中心',
    download_click: '点击下载客户端',

    siteMap: '网站导航',
    siteMap_course: '课程介绍',
    siteMap_team: '教师',
    siteMap_recruit: '教师招聘',

    about: '关于我们',
    about_intro: '哈兔简介',
    about_report: '媒体报道',
    about_contact: '联系我们',

    cooperate: '商务合作',
    cooperate_contact: '推广合作 ',
    cooperate_email: '邮件联系',

    question: '常见问题',
    question_issue: '常见问题',
    question_privacy: '隐私申明',

    media: '社交媒体',
    media_wechat: '微信公众号',
    media_service: '联系客服',

    bottom: '底部',
    bottom_tel: '电话',
    bottom_email: '邮箱',
    bottom_site: '地址',
    bottom_icp: 'IHATOO©2020哈兔中文网络科技有限公司-浙ICP备15040512号',
};